var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wh-container"},[_vm._m(0),_c('Tab',{ref:"tiss_tabs",attrs:{"index":_vm.currentTabIndex,"keys":_vm.tabs},on:{"onChange":_vm.onChangeTab}},[_c('router-view')],1),_c('PrintBatchModal',{ref:"printBatchModal"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header no-print"},[_c('p',{staticClass:"title"},[_vm._v("Faturamento TISS")])])
}]

export { render, staticRenderFns }